import { isFunction } from "../../data/utils.js";
import { Control } from "../Control.js";
import { resolveValue } from "../utils/ui-helpers.js";

export class Tabs extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            tabs = [],
            activeTabKey = null,
            onActiveTabKeyChange = null,
            onTabRender = null,
        } = options;

        this.tabs = tabs;
        this.activeTabKey = activeTabKey;
        this.onActiveTabKeyChange = onActiveTabKeyChange;
        this.onTabRender = onTabRender;

    };

    /**
     * tabs: [ { key, label, icon }... ]
     */
    getTabs() { return resolveValue(this.tabs); };

    getActiveTabKey() { return resolveValue(this.activeTabKey); }

    _activeTabKeyChaned(key) {

        if (isFunction(this.onActiveTabKeyChange))
            this.onActiveTabKeyChange(key);

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;
        const that = this;

        let tabs = this.getTabs(),
            activeTabKey = this.getActiveTabKey();

        return renderer.nav({ css: 'tabs' }, (tabs || []).map((tab) => {

            let tabContent = [];

            if (this.onTabRender) {
                tabContent = this.onTabRender(tab);
            } else {
                if (tab.icon) tabContent.push(renderer.icon(tab.icon));
                if (tab.label) tabContent.push(renderer.el('span', null, null, [tab.label]));
            }

            return renderer.link({
                css: tab.key == activeTabKey ? 'active' : null,
                props: {
                    onclick: (e) => {
                        e.preventDefault();
                        that._activeTabKeyChaned(tab.key);
                    }
                }
            }, tabContent);

        }));

    };

}